// Období dotažení z to_fill.params → čitelný český formát podle granularity
// (viz doc/plans/to-fill-human-labels.md, Rozhodnutí C — revize 2026-09-10).
//
// Tvar params podle zdroje:
//   DAILY  (/api/daily_ts/fill)      → begin_date, end_date (ISO UTC)
//   SDATA  (/api/sdata_ts/fill)      → year_from, year_to, stype       (dotahované roky)
//   SDATA  (/api/sndata_ts/fill)     → gfirst_year, glast_year, stype  (ref. období normálu)
//   SEDATA (/api/sedata_ts/fill)     → gfirst_year, glast_year, stype  (ref. období extrémů)
//   PHENO  (/api/phenomena_day/fill) → from, to (YYYY-MM)              (měsíc jevů)
//
// Formát podle obs_type (z ts_info řádku pro DAILY):
//   10M / HLY → "10.9.2026 00:00 – 10.9.2026 23:50"   (datum + čas)
//   DLY       → "1.9.2026 – 30.9.2026"                 (jen datum)
//   MONTH     → "9/2026"                               (měsíc)
//   YEAR      → "2026"
//   SDATA/SEDATA (roky) → "2020 – 2026" / "2026"
import { typFromEndpoint } from './tsTyp'

const DASH = ' – '

// ISO UTC string → { y, m, d, hh, mm } (UTC složky, bez převodu TZ — okna
// posílá server, pro zobrazení bereme 1:1).
function parts(iso) {
  const dt = new Date(iso)
  return {
    y: dt.getUTCFullYear(),
    m: dt.getUTCMonth() + 1,
    d: dt.getUTCDate(),
    hh: dt.getUTCHours(),
    mm: dt.getUTCMinutes(),
  }
}

const pad2 = (n) => String(n).padStart(2, '0')
const dmy = (p) => `${p.d}.${p.m}.${p.y}`
const dmyhm = (p) => `${p.d}.${p.m}.${p.y} ${pad2(p.hh)}:${pad2(p.mm)}`

const yearRange = (a, b) => (String(a) === String(b) ? `${a}` : `${a}${DASH}${b}`)

// item = to_fill položka; info = ts_info řádek (nebo undefined) — kvůli obs_type
export function toFillPeriod(item, info) {
  const p = item?.params || {}

  // jevy (phenomena_day) — from/to jako YYYY-MM
  if (p.from != null || p.to != null) {
    const fmtM = (s) => {
      const [y, m] = String(s).split('-')
      return m ? `${Number(m)}/${y}` : `${y}`
    }
    const f = p.from ?? p.to
    return String(p.from) === String(p.to) ? fmtM(f) : `${fmtM(p.from)}${DASH}${fmtM(p.to)}`
  }

  // sezónní řady — roky
  if (p.year_from != null || p.year_to != null)
    return yearRange(p.year_from ?? '', p.year_to ?? '')
  if (p.gfirst_year != null || p.glast_year != null)
    return yearRange(p.gfirst_year ?? '', p.glast_year ?? '')

  // daily řady — begin_date / end_date
  if (!p.begin_date || !p.end_date) return p.begin_date || ''
  const a = parts(p.begin_date)
  const b = parts(p.end_date)

  const typ = typFromEndpoint(item?.endpoint)
  const obs = typ === 'DAILY' ? info?.obs_type : null

  if (obs === 'YEAR') return yearRange(a.y, b.y)
  if (obs === 'MONTH') {
    return a.y === b.y && a.m === b.m ? `${a.m}/${a.y}` : `${a.m}/${a.y}${DASH}${b.m}/${b.y}`
  }
  if (obs === 'DLY') {
    return dmy(a) === dmy(b) ? dmy(a) : `${dmy(a)}${DASH}${dmy(b)}`
  }
  // 10M / HLY (a fallback bez obs_type) — datum + čas
  return `${dmyhm(a)}${DASH}${dmyhm(b)}`
}
